import { useOrganizationAccountQuery, useCreateOrganizationAccountMutation, useUpdateOrganizationAccountMutation, useDeactivateOrganizationAccountMutation } from './useOrganizationAccountsQuery';
import { OrganizationAccount } from '../types';

export const useOrganizationAccount = (accountId?: string) => {
    const { data: record, isLoading: loading, refetch: fetchRecord } = useOrganizationAccountQuery(accountId || '');
    const createOrganizationAccountMutation = useCreateOrganizationAccountMutation();
    const updateOrganizationAccountMutation = useUpdateOrganizationAccountMutation();
    const deactivateOrganizationAccountMutation = useDeactivateOrganizationAccountMutation();

    const createRecord = async (values: OrganizationAccount) => {
        return await createOrganizationAccountMutation.mutateAsync(values);
    };

    const updateRecord = async (values: OrganizationAccount) => {
        if (typeof accountId === 'undefined') {
            throw new Error('accountId is required parameter');
        }
        return await updateOrganizationAccountMutation.mutateAsync({ id: accountId, record: values });
    };

    const deactivateRecord = async () => {
        if (typeof accountId === 'undefined') {
            throw new Error('accountId is required parameter');
        }
        return await deactivateOrganizationAccountMutation.mutateAsync(accountId);
    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deactivateRecord,
    };
};
